import { Form, Field } from 'react-final-form'
import createDecorator from 'final-form-focus'
import { FormattedMessage } from 'react-intl'
import { isValidEmail } from '../../utils'
import { createUrl } from '../../localized-urls'
import API from '../../api'
import { FORM_ERROR } from 'final-form'
import { FinalFormInput } from '../forms/Input'
import { saveToken, setUser } from './auth'
import store from 'store2'
import { submitReview } from '../popups/ReviewPopup'

const focusOnError = createDecorator()

const validate = (values) => {
  const errors = {}

  if(!values.username) {
    errors.username = (
      <FormattedMessage
        id='required_field'
        defaultMessage='This field is required!'
      />
    )
  } else if(!isValidEmail(values.username)) {
    errors.username = (
      <FormattedMessage
        id='error-email-invalid'
        defaultMessage='Invalid email address'
      />
    )
  }

  if(!values.password) {
    errors.password = (
      <FormattedMessage
        id='required_field'
        defaultMessage='This field is required!'
      />
    )
  }

  return errors
}

const ErrorLists = ({ arr }) => {
  return arr.map((item) => (
    <strong key={item} className='red-text'>
      {item}
    </strong>
  ))
}

export default ({ setForgot, onSubmitSuccess, hidePasswordRestore }) => {
  const onSuccess = (result) => {
    if(typeof onSubmitSuccess === 'function') {
      onSubmitSuccess(result.user)
    } else {
      window.location.href = createUrl('bookings')
    }
  }
  const loginRequest = (credentials) => {
    return API('account/login/')
      .post(credentials)
      .then((result) => {
        saveToken(result.token)
        setUser(result.user)
        window.localStorage.removeItem('coupon')
        window.localStorage.setItem('paymentInfo', false)
        const reviewData = store('reviewData')
        if(reviewData) {
          store.remove('reviewData')
          submitReview(reviewData.shopSlug, reviewData).then(() =>
            onSuccess(result)
          )
        } else {
          onSuccess(result)
        }
      })
      .catch(({ error }) => {
        return { [FORM_ERROR]: [Object.values(error)] }
      })
  }

  return (
    <div>
      <Form
        onSubmit={loginRequest}
        decorators={[focusOnError]}
        validate={validate}
        subscription={{
          value: true,
          active: true,
          error: true,
          touched: true,
          submitted: true,
          submitError: true,
        }}
      >
        {({ handleSubmit, submitError }) => (
          <form className='form' onSubmit={handleSubmit}>
            <div>
              <Field
                name='username'
                component={FinalFormInput}
                icon={
                  <img
                    className='icon'
                    src={`${window.staticPath}travel_dist/images/mail.svg`}
                  />
                }
                label={<FormattedMessage id='email' defaultMessage='Email' />}
              />
            </div>
            <div>
              <Field
                name='password'
                type='password'
                component={FinalFormInput}
                icon={
                  <img
                    className='icon'
                    src={`${window.staticPath}travel_dist/images/lock.svg`}
                  />
                }
                label={
                  <FormattedMessage id='password' defaultMessage='Password' />
                }
              />
            </div>
            {!hidePasswordRestore && (
              <div className='pass-reset'>
                <a onClick={() => setForgot(true)}>
                  <FormattedMessage
                    id='reset'
                    defaultMessage='I’ve forgotten my Password'
                  />
                </a>
              </div>
            )}
            <div>
              <button type='submit' className='btn btn-red'>
                <FormattedMessage id='login_in_btn' defaultMessage='Log in' />
              </button>
            </div>
            <p className='note'>
              *
              <FormattedMessage
                id='login-note'
                defaultMessage=' Please note that if you`ve previously created an account either on Diviac logbook or Diviac travel, you can continue to use those credentials to login to PADI Travel. PADI pro, Scubaearth and PADI Club credentials can’t be used yet to login to PADI Travel.'
              />
            </p>

            {submitError && (
              <p className='server-errors'>
                <ErrorLists arr={submitError} />
              </p>
            )}
          </form>
        )}
      </Form>
    </div>
  )
}
